<template>
    <div v-if="itemsTable">
        <v-data-table :headers="headers" :items="itemsTable" :search="search"
                      class="elevation-1" hide-default-footer
                      @page-count="pageCount = $event" :page.sync="page" :items-per-page="itemsPerPage">
            <template v-slot:top>
                <v-toolbar flat color="grey" dark :extension-height="$vuetify.breakpoint.xsOnly?136: 48">
                    <verein-edit-menu v-if="user" :id="verein.id" @vereinsAction="vereinsAction" :lv-id="lv.id"/>
                    <v-toolbar-title><span class="heebo fw400">{{verein.id}} - {{verein.name}}</span>
                        <v-chip v-if="verein.inaktiv" color="primary" class="ml-2"><v-icon class="mr-1" small>
                            mdi-delete</v-icon>INAKTIV !!!</v-chip>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <!--<v-divider class="mx-4" inset vertical></v-divider>-->
                    <v-btn v-if="$vuetify.breakpoint.smAndUp" color="primary" depressed @click="addItem()">
                        <v-icon>mdi-plus</v-icon>Neues Mitglied</v-btn>
                    <template v-slot:extension>
                        <div style="width: 100%">
                        <div v-if="$vuetify.breakpoint.xsOnly" >
                            <v-checkbox dark class="my-3" v-model="searchInactive" hide-details label="inaktive Mitglieder anzeigen">
                            </v-checkbox>
                            <v-btn block color="primary" depressed @click="addItem()">Neues Mitglied</v-btn>
                            <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
                                          label="Suchen" solo flat dense light class="mt-3 mb-5 white"
                                          single-line hide-details>
                                <template v-slot:append>
                                    <v-btn icon small class="pb-1">
                                        <v-icon style="cursor: pointer" @click="search=''">mdi-close</v-icon>
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </div>
                        <v-row v-else align="center">
                            <v-col cols="6">
                                <v-checkbox dark class="mt-2" v-model="searchInactive" label="inaktive Mitglieder anzeigen">
                                </v-checkbox></v-col>
                            <v-col cols="6">
                                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"
                                              label="Suchen" solo flat dense light class="mb-3 white"
                                              single-line hide-details  >
                                    <template v-slot:append>
                                        <v-btn icon small class="pb-1">
                                            <v-icon style="cursor: pointer" @click="search=''">mdi-close</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>
                        </div>
                    </template>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <span v-if="item.search.passStatus !== 'in Bearbeitung' && item.search.passStatus !== 'beantragt'">
                    <v-icon @click="openInfo(item)" class="mr-4">
                            mdi-information-outline
                    </v-icon>
                </span>
                <span v-for="(action, i) in item.spielerActions" :key="i">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span v-if="action.msg"
                                  class="caption red--text font-weight-bold"
                                  style="line-height: 1.4" v-html="action.msg">
                            </span>
                            <span v-else>
                                <div v-if="action.pending" class="badge d-inline-block warning"></div>
                                <div v-if="item.url && action.actionType==='foto'" class="badge d-inline-block success"></div>
                                <v-icon v-bind="attrs" v-on="on" :color="action.color"
                                        @click="itemAction(item, action.actionType)" class="mr-4">
                                    {{action.icon}}
                                </v-icon>
                            </span>
                        </template>
                        <span>{{action.toolTip}}</span>
                    </v-tooltip>
                </span>
            </template>
            <template v-slot:no-data>
                Zu dieser Auswahl sind keine Mitglieder gespeichert!
            </template>
        </v-data-table>
        <v-pagination v-if="pageCount>1" v-model="page" :length="pageCount"></v-pagination>
        <div v-if="$vuetify.breakpoint.xsOnly" class="py-8"></div>
    <!-- edit & action forms -->
        <spieler-pass-duplikat action="passDuplikat" :actionObject="newAction"
                               @saveAction="saveActionItem"
                               @cancelAction="cancelItemActionFromDialog">
        </spieler-pass-duplikat>
        <spieler-delete action="loeschen" :actionObject="newAction" @actionSnack="setActionSnackbar"/>
        <spieler-print action="drucken" :actionObject="newAction" @actionSnack="setActionSnackbar"/>
        <spieler-foto action="foto" :actionObject="newAction" @actionSnack="setActionSnackbar"/>
        <spieler-new-edit :dataObject="newItem" :action="action" @actionSnack="setActionSnackbar"
                          :current-data="editedItem" :verein="verein" :lv="lv">
        </spieler-new-edit>
        <spieler-bestaetigungen :spieler="bestaetigungenItem" action="bestaetigungen"
                                :actionObject="newAction" @actionSnack="setActionSnackbar">
        </spieler-bestaetigungen>
        <spieler-status :spieler="statusItem" :action="newAction?newAction.actionType:''" :actionObject="newAction" :lv="lv"
                                @saveAction="saveActionItem"
                                @cancelAction="cancelItemActionFromDialog">
        </spieler-status>
        <spieler-ummeldung :spieler="ummeldungItem" :actionObject="newAction" action="ummeldung"
                           :lv="lv" @actionSnack="setActionSnackbar"
                           @cancelAction="cancelItemActionFromDialog" @saveAction="saveActionItem">
        </spieler-ummeldung>
        <spieler-leihe :spieler="leiheItem" :actionObject="newAction" action="leihe"
                       :lv="lv" @actionSnack="setActionSnackbar">
        </spieler-leihe>
        <confirm-dialog :open="confirmDelete.open" :question="confirmDelete.question"
                        @reply="deleteSpieler" :query-parameter="confirmDelete">
        </confirm-dialog>
    <!-- Info Container -->
        <spieler-info :spieler="spielerInfo">
        </spieler-info>
    <!-- snackbars -->
        <snackbar :msg="actionSnack">
        </snackbar>
    </div>
</template>

<script>
import {Spieler} from "../../services/data/spieler/spieler";
import SpielerNewEdit from "./spielerEdit/spielerNewEdit";
import SpielerActionIconList from "../../services/data/spielerActionIcons/spielerActionIconList";
import SpielerPassDuplikat from "./spielerEdit/spielerPassDuplikat";
import {SpielerAction} from "../../services/data/spielerAction/spielerAction";
import Snackbar from "../../components/elements/snackbar";
import ConfirmDialog from "../../components/navigation/confirmDialog";
import SpielerStatus from "./spielerEdit/spielerStatus";
import SpielerBestaetigungen from "./spielerEdit/spielerBestaetigungen";
import SpielerUmmeldung from "./spielerEdit/spielerUmmeldung";
import TimeStamp from "../../services/timeStamp";
import SpielerInfo from "./spielerInfo/spielerInfo";
import VereinEditMenu from "../landesverband/vereinEditMenu";
import SPIELER_CHANGE_HANDLER from "../../services/data/spieler/spielerChangeHandler";
import SPIELER_MEMBERSHIP_HANDLER from "../../services/data/spieler/spielerMembershipHandler";
import DATABASE_HANDLER from "../../services/database/databaseHandler";
import SpielerDelete from "./spielerEdit/spielerDelete";
import SpielerFoto from "./spielerEdit/spielerFoto";
import {CloudStorageHandler} from "../../services/storage/cloudStorageHandler";
import SpielerLeihe from "./spielerEdit/spielerLeihe";
import FirebaseWrite from "@/services/database/firebaseWrite";
import SpielerPrint from "@/views/spielerTabelle/spielerEdit/spielerPrint";

export default {
    components: {
        SpielerPrint,
        SpielerLeihe,
        SpielerFoto,
        SpielerDelete,
        VereinEditMenu,
        SpielerInfo,
        SpielerUmmeldung,
        SpielerBestaetigungen,
        SpielerStatus,
        ConfirmDialog,
        Snackbar,
        SpielerPassDuplikat,
        SpielerNewEdit},
    name: "spieler-tabelle",
    props: ['verein', 'items', 'itemsExpired', 'columnListName', 'sportJahr', 'lv'],
    computed: {
        pendingActions(){ return this.$store.state.realtime.pendingActions },
        user(){ return this.$store.state.user; },
    },
    data: () => ({
        headers: [],
        itemsTable: [],
        //dialogDelete: false,
        search: '',
        searchInactive: false,
        newItem: null,
        newAction: null,
        editedItem: null,
        bestaetigungenItem: null,
        ummeldungItem: null,
        leiheItem: null,
        statusItem: null,
        action: '',
        actionSnack: {
            show: false,
            color: 'error',
            timeout: 4000,
            text: '',
            dynamicText: null,
            actionButtonI18n: '',
        },
        confirmDelete: {
            open: false,
            question: 'Möchtest du dieses Mitglied wirklich endgültig löschen?',
            item: null,
        },
        spielerInfo: null,
    // pagination
        page: 1,
        pageCount: 0,
        itemsPerPage: 15,
    }),
    created () {
        this.initialize()
    },
    methods: {
        openInfo(item){
            this.spielerInfo = item;
            console.log ("spielerInfo", this.spielerInfo);
            this.tableAction ('route', 'spielerInfo')
        },
        setTableItems(){
            this.itemsTable = [];
            setTimeout(()=>{
                    let itemsTemp = [];
                    itemsTemp = this.setItems('items', itemsTemp);
                    if ( !this.searchInactive ) { itemsTemp = this.setItems('itemsExpired', itemsTemp) }
                    this.itemsTable = itemsTemp.sort((a, b) => a.nachname > b.nachname ? 1 : -1);
            }, 50);
        },
            setItems(itemType, itemsTemp){
                this[itemType].forEach( (item) => {
                    //if ( item.status === 'aktiv' || (item.status === 'inaktiv' && this.searchInactive) ) {
                        if ( item.status === 'aktiv') {
                            item.passNr = SPIELER_CHANGE_HANDLER.getPassNumberForSportJahrValue(item); // , this.sportJahr, false
                            if ( item.passNr === 'beantragt' ) item.passNr = 'bitte Foto hochladen'
                        } else {
                            item.passNr = SPIELER_MEMBERSHIP_HANDLER.getLastRegularPassNr(item.memberships);
                        }
                        item.spielerActions = SpielerActionIconList.getForSpieler(item, this.pendingActions,
                            this.verein, this.lv);
                        if ( Number.isFinite(item.letzteAenderung) ) {
                            /*item.letzteAenderung = TimeStamp.getLocalDate(item.letzteAenderung) + ' ' +
                                                   TimeStamp.getLocalTime(item.letzteAenderung, true);*/
                            item.letzteAenderung = TimeStamp.getTimeSince(item.letzteAenderung)
                        }
                    // set display status for list aktiv, inaktiv + abgelaufen (only available in display)
                        if ( !item.local ) {
                            item.local = {statusDisplay: itemType === 'itemsExpired' ? 'abgelaufen' : item.status}
                        } else {
                            item.local.statusDisplay = itemType === 'itemsExpired' ? 'abgelaufen' : item.status;
                        }
                    // overwrite item status with leihspieler
                        item = SPIELER_MEMBERSHIP_HANDLER.overwriteWithLeihe(item, this.lv.id + this.verein.id,
                                                                                    this.sportJahr);
                    // push item
                        if ( this.searchInactive ||
                            ( !this.searchInactive && item.status !== 'inaktiv' )) {
                            itemsTemp.push(item);
                        }
                    //}
                });
                return itemsTemp;
            },
        initialize () {
            this.newItem = new Spieler();
            this.setTableItems();
            this.headers = this.newItem.getTableHeaders(this.columnListName);
            this.headers.push({ text: 'Aktionen', value: 'actions', sortable: false })
        },
        tableAction (type, key){
            if ( type === 'route' ) {
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                q.action = key;
                this.$router.push({path: p, query: q});
            }
        },
        addItem(){
            this.action = 'addPlayer';
            this.editedItem = null;
            this.tableAction('route', 'addPlayer')
        },

        editItem (item, action) {
            this.action = action; //'editPlayer';
            this.editedItem = item;
            this.tableAction('route', action)
        },
        itemAction (item, action) {
        // special treatment for edits
            if ( action === 'resetToBeantragt' ) {
                this.resetToBeantragt(item);
                return;
            } else if ( action === 'editNew' || action === 'edit' ) {
                this.editItem(item, action);
                return;
            } else if ( action === 'delete' ) {
                this.confirmDelete.item = item;
                this.confirmDelete.open = true;
                return;
            }
        // other actions
            this.newAction = new SpielerAction(item, action, this.lv.id, this.verein.id);
            let field = action === 'bestaetigungen' || action === 'ummeldung' || action === 'leihe' ? action + 'Item' : 'statusItem';
            //if ( action === 'bestaetigungen' || action === 'ummeldung' ) {
            //    let field = action + 'Item';
                this[field] = new Spieler();
                this[field].setCurrentData(item);
            //}
            this.tableAction('route', action)
        },

        async saveActionItem(spielerAction, text, printPass, isPassDuplicate, autoConfirmAction, clearPassPrint){
            spielerAction.setTimeStamp();
            // 2023 start
            if ( autoConfirmAction ) {
                spielerAction.autoConfirmDuplicateAndContentChanges(true)
            }
            // 2023 end
            let reply = await spielerAction.saveNew('document');
            if ( reply.successful ) {
            //snack success
                this.actionSnack.color = 'success';
                this.actionSnack.text = text.success ? text.success : 'Die Aktion war erfolgreich!'
            // 2023: set passprint on player
                if ( printPass ) {
                    FirebaseWrite.update('spieler', spielerAction.search_spieler,
                        SPIELER_CHANGE_HANDLER.addPassPrintParameterToDbObject({}, true,
                            isPassDuplicate ? true:false)
                    )
                }
                if ( clearPassPrint ) {
                    const dataObject = await SPIELER_CHANGE_HANDLER.clearSpielerPassPrint({}, spielerAction.search_spieler)
                    FirebaseWrite.update('spieler', spielerAction.search_spieler, dataObject)
                }
            // 2023 end: set passprint on player
            } else {
            // es ist ein Fehler aufgetreten
                this.actionSnack.text = 'Es ist leider ein Fehler aufgetreten! Probiere es bitte später nochmals!'
            }
            this.actionSnack.show = true;
        },

        cancelItemActionFromDialog(actionItem, spielerAction){
            spielerAction.setFromDataObject(actionItem);
            this.deleteActionItem(spielerAction);
        },
            async deleteActionItem(spielerAction){
                let reply = await spielerAction.deleteWithTransaction('spielerActionDelete', true);
                if ( reply.successful ) {
                    //snack success
                    this.actionSnack.color = 'success';
                    this.actionSnack.text = 'Die Aktion wurde erfolgreich storniert!'
                } else {
                    if ( reply.content === 'Verification failed!' ) {
                    // schon bearbeitet in der Zwischenzeit
                        this.actionSnack.text = 'Die Aktion konnte nicht mehr storniert werden, ' +
                            'da sie in der Zwischenzeit verarbeitet wurde!'
                    } else {
                    // es ist ein Fehler aufgetreten
                        this.actionSnack.text = 'Es ist leider ein Fehler aufgetreten!'
                    }
                }
                this.actionSnack.show = true;
            },
        setActionSnackbar(snack){
            this.actionSnack.text = snack.text;
            this.actionSnack.color = snack.color;
            this.actionSnack.show = true;
        },
        deleteSpieler(reply){
            this.confirmDelete.open = false;
            if ( !reply ) { return }
            this.deleteSpielerDocs();
        },
            async deleteSpielerDocs(){
                let spieler = new Spieler();
                spieler.setFromDataObject(this.confirmDelete.item);
                let reply = await spieler.deleteWithTransaction('spieler_delete', true);
                if ( reply.successful ) {
                // delete img
                    if ( spieler.url ) {
                        const cloudStorageHandler = new CloudStorageHandler();
                        await cloudStorageHandler.deleteFile('/passfotos/' + spieler.id + '.jpeg');
                    }
                // delete private document
                    await spieler.deleteDocument('spieler_delete_private');
                //snack success
                    this.actionSnack.color = 'success';
                    this.actionSnack.text = 'Das Mitglied wurde erfolgreich gelöscht!'
                } else {
                    if ( reply.content === 'Verification failed!' ) {
                    // schon bearbeitet in der Zwischenzeit
                        this.actionSnack.text = 'Das Mitglied konnte nicht mehr gelöscht werden, ' +
                            'weil in der Zwischenzeit die Verarbeitung begonnen hat!'
                    } else {
                    // es ist ein Fehler aufgetreten
                        this.actionSnack.text = 'Es ist leider ein Fehler aufgetreten!'
                    }
                }
                this.actionSnack.show = true;
            },
        vereinsAction(action){
            this.$emit('vereinsAction', action);
        },
        async resetToBeantragt(item){
            let spieler = JSON.parse(JSON.stringify(item));
            spieler.local = {};
            spieler.id = item.id;
            let isUmmeldung = false; let i = 0;
            console.log ("spieler.memberships", spieler.memberships);
            spieler.memberships.forEach( (membership) => {
                if ( membership.passNr === 'ummeldung' ) {
                    isUmmeldung = true;
                    spieler.dates.lastSportTag = membership.from.substr(0,4) + '-06-30';
                    spieler.memberships.splice(i, 1);
                    spieler.search.passStatus = ''
                }
                i++;
            });
            spieler.local.documentUpdates = !isUmmeldung ?
                { 'search.passStatus': 'beantragt' } :
                {   memberships: spieler.memberships,
                    search: SPIELER_CHANGE_HANDLER.search_setBasedOnMembership(spieler.search, spieler.memberships),
                    'dates.lastSportTag': spieler.dates.lastSportTag
                }
            ;
            console.log ("itemID", item.id);
            console.log ("resetToBeantragt", spieler);
            await DATABASE_HANDLER.updateWithTransaction('spieler_edit', false, spieler);
        },
    },
    watch: {
        items(){
            console.log ("WATCH ITEMS");
            this.setTableItems();
        },
        pendingActions(){
            console.log ("WATCH pendingActions");
            this.setTableItems();
        },
        searchInactive(){
            this.$emit('searchStatusChanged', this.searchInactive);
        },
        verein(){
            this.searchInactive = false;
        },
        '$route.query.imgId'(){
            let imgId = this.$route.query.imgId;
            if ( imgId ) {
                window.history.back();
                setTimeout(()=>{
                        let item = this.itemsTable.find(item => item.id === imgId );
                        this.itemAction (item, 'foto')
                    }
                    ,200);
            }
        }
    },
}
</script>

<style scoped>
    .badge {width: 8px; height: 8px; border-radius: 4px; position: absolute; z-index: 5 }
</style>